import { IApplicationState } from '../../types/redux';

export function selectLocationsStatus(state: IApplicationState) {
  return state.buildersLocations.status;
}
